import { render, staticRenderFns } from "./GridDisplay.vue?vue&type=template&id=48d4256c&lang=pug&"
import script from "./GridDisplay.vue?vue&type=script&lang=js&"
export * from "./GridDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports